// calculator-basic.js (block JS)
import { initSmarty } from '../utilities/smarty';
import { sendTrack } from '../utilities/track';
import { basicCalculatorInit } from '../utilities/calculator-basic';

document.addEventListener('DOMContentLoaded', () => {
  const calculators = document.querySelectorAll('.calculator-basic');

  for (const el of calculators) {
    const id = `#${el.id}`;
    if (!el.id) continue;

    const applyBtnSelector = '.check-equity-button';
    const applyBtnEl = el.querySelector(applyBtnSelector);
    const buttonIdleText = applyBtnEl?.dataset?.return?.trim() || 'Apply Now';
    const utmContent = applyBtnEl?.dataset?.utm?.trim();
    let smartyQualUrl = globalThis.unlk?.smartyQual;

    if (utmContent && smartyQualUrl) {
      const url = new URL(smartyQualUrl, globalThis.location.origin);
      url.searchParams.set('utm_content', utmContent);
      smartyQualUrl = url.toString();
    }

    basicCalculatorInit({
      initSmarty,
      sendTrack,
      smartyNavigation: { mode: 'cta', cta: { dataAttr: 'href' } },

      unlk: {
        publicOffer: globalThis.unlk?.publicOffer,
        smartyKey: globalThis.unlk?.smartyKey,
        activeStates: globalThis.unlk?.activeStates || [],
        estimateUrl: globalThis.unlk?.estimate,
        smartyQualUrl,
        smartyNonQualUrl: globalThis.unlk?.smartyNonQual
      },

      selectors: {
        root: id,

        homeValueInput: '#home-value',
        homeValueSlider: '#home-value-slider',
        debtValueInput: '#debt-value',
        debtValueSlider: '#debt-value-slider',

        calculatorNotice: '.calculator-notice',
        addressNotice: '.address-notice',
        applyBtn: applyBtnSelector,
        responseValueTarget: 'response-value',

        smarty: {
          addressInput: '#equity-autocomplete-address',
          inputGroup: '.calculator-basic .input-group',
          suggestionBox: '#equity-suggestions',
          qualButton: '.check-equity-button',
          buttonIdle: buttonIdleText,
          invalidScope: id
        }
      },

      notices: {
        debtClampedText:
          'Your debt was adjusted to {value} because it can’t exceed your home value.',
        offerEquityTooLowText:
          'We cannot make an offer because the available equity is too low. Please try lowering how much you owe.',
        noEstimatesHtml:
          "We weren't able to estimate what your home is worth. Please enter an estimated value above.<br>The estimate you provide will be confirmed by an appraisal if you move forward."
      }
    });
  }
});
